import { PaginationRequestModel } from '@dental-ui/shared/models';

/**
 * GetAllNotificationByFilter gövdesindeki notificationDto ile uyumlu filtre modeli.
 */
export class NotificationFilterDto {
  sharedUserId = '';
  type: number | null = null;
  subType: number | null = null;
  title = '';
  description = '';

  setData(data: Partial<NotificationFilterDto>): void {
    Object.assign(this, data);
  }

  clear(): void {
    this.sharedUserId = '';
    this.type = null;
    this.subType = null;
    this.title = '';
    this.description = '';
  }
}

export class NotificationFilterRequest {
  paginationRequestModel: PaginationRequestModel = new PaginationRequestModel();
  notificationDto: NotificationFilterDto = new NotificationFilterDto();

  setData(data: Partial<NotificationFilterRequest>): void {
    if (data.paginationRequestModel) {
      this.paginationRequestModel.setData(data.paginationRequestModel);
    }
    if (data.notificationDto) {
      this.notificationDto.setData(data.notificationDto);
    }
  }

  clear(): void {
    this.paginationRequestModel.clear();
    this.notificationDto.clear();
  }
}
